
<div class="content-section">
    <app-trial-license-warning></app-trial-license-warning>
    <lib-campaigns></lib-campaigns>
    <div class="title-section title-bar title-bar-nav">
        <div class="title-div">
                <div class="col p-0 d-flex justify-content-between align-items-center changeInstitution">
                    <div class="col-11 p-0">
                        <h2 class="background_title">{{ 'CONFIGURE.CONSUMPTION' | translate }}</h2>
                        <div class="col-auto d-flex justify-content-md-end justify-content-sm-start">
                            <!-- <div class="col-auto institution-name p-0">
                                <img src="assets/img/menuActive/Institution.svg" alt="Institution" (click)="openmodal(template)">
                                <p class="m-0 selectedInsText cursor" *ngIf='showInstitutionDropDown()'>
                                    {{selectedInstitution | labelSanitizer}}
                                    <a class="menuLink tooltipEvalution">
                                        <img src="assets/img/svg/icon-change.svg">
                                        <span class="tooltiptext">{{ 'LAYOUT_MODULE.CHANGE_INSTITUTION' | translate }}</span>
                                    </a>
                                </p>
                                <p class="m-0" *ngIf='!showInstitutionDropDown()'>{{getInstitutionName() | labelSanitizer}}</p>
                            </div> -->
                        </div>
                    </div>
                </div> 
        </div>
        <div class="container-nav">
            <nav class="nav nav-pills nav-title">
                <a class="nav-link" *ngIf="appConfig.viewconsumption && !appConfig.editconsumption" routerLink="/consumption/new" routerLinkActive='active'>{{ 'CONSUMPTION.CONSUMPTION.NEW' | translate }}</a>
            <a class="nav-link" *ngIf="!appConfig.viewconsumption && !appConfig.editconsumption" routerLink="/consumption/new" routerLinkActive='active'>{{ 'CONSUMPTION.CONSUMPTION.VIEW' | translate }}</a>
            <a class="nav-link" *ngIf="appConfig.editconsumption" routerLink="/consumption/new" routerLinkActive='active'>{{ 'CONSUMPTION.CONSUMPTION.EDIT' | translate }}</a>
            <a class="nav-link" routerLink="/consumption/past" (click)="appConfig.viewconsumption =true;appConfig.editconsumption = false" routerLinkActive='active'>{{ 'CONSUMPTION.CONSUMPTION.SUMMARISED' | translate }}</a>
           </nav> 
           <hr class="nav-separator">
             <!-- <div class="d-block d-md-none">
                <div class="btn-group btn-block customDropdown" dropdown>
                    <button id="button-basic" dropdownToggle type="button" class="btn btn-muted btn-block dropdown-toggle" aria-controls="dropdown-basic">
             
            </button>
                    <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu btn-block customDropdownList" role="menu" aria-labelledby="button-basic">
                      
                        <li role="menuitem active">
                            <a class="nav-link" routerLink=institutionDetailTabs[0].url routerLinkActive='active'>{{institutionDetailTabs[0].title | translate}}</a>
                        </li>
                        <li role="menuitem">
                            <a class="nav-link" routerLink=institutionDetailTabs[1].url routerLinkActive='active'>{{institutionDetailTabs[1].title | translate}}</a>
                        </li>
                    </ul>
                </div>
            </div> -->
        </div>
    </div> 
    <div class="container-section-nav"> 
        <router-outlet></router-outlet>
    </div>
</div>




<ng-template #template>
    <div class="modal-header justify-content-between align-items-center">
        <h5 class="modal-title" id="exampleModalLabel">{{ translationKeys.UserProfiles.SelectInsititutions | translate }}</h5>
        <a class="cursor" aria-label="Close" (click)="modalRef.hide()"><img src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="modal-body" data-simplebar class="change-lang">
        <div [formGroup]="mygroup" class="col-12">
            <div class="mb-2 form-check" *ngFor='let Institutions of InstitutionsList;let i = index'>
                <input type="radio" [value]="Institutions.institution.institutionID" name="selectedIns" *ngIf="showInstitutionDropDown()" formControlName="selectedIns" class="form-check-input" id={{Institutions.institution.institutionID}}>
                <label class="form-check-label" for={{Institutions.institution.institutionID}}>{{Institutions.institution.institutionName | labelSanitizer}}</label>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="container-fluid">
            <div class="row">
                <div class="col my-3 justify-content-end align-items-center d-flex">
                    <button type="button" class="btn btn-continue-bordered-bd" (click)="modalRef.hide();onInstitutionChange(mygroup.value.selectedIns);">{{ translationKeys.Authorization.Done | translate }}</button>
                </div>
            </div>
        </div>
    </div>



    
</ng-template>